import styled from "styled-components"
import { grey } from "utilities/variables/colors"

export const StyledFooter = styled.footer`
  position: relative;
  background-color: #F8F9FA;
  border-top: solid 1px ${grey};
  padding-bottom: env(safe-area-inset-bottom, 0);
`